export default "__VITE_ASSET__B6maTrBR__"